import React, { ReactNode } from 'react';
import CardList from '../CardList';
import CalendarDashboardEvent, { Event } from '../CalendarDashboardEvent';

export type CalendarCardListProps = {
  title?: string;
  seeAllLink?: ReactNode;
  height?: string;
  loading?: boolean;
  fallback?: ReactNode;
  events: Event[];
  onItemClick?: (item: any) => void;
  onHover?: boolean;
};

const TCalendarCardList: React.FC<CalendarCardListProps> = ({
  title,
  seeAllLink,
  events = [],
  loading = false,
  height,
  fallback,
  onItemClick = () => {},
  onHover = false,
}) => {
  return (
    <CardList
      title={title}
      seeAllLink={seeAllLink}
      loading={loading}
      height={height}
      fallback={fallback}
      onHover={onHover}
    >
      {events.length
        ? events.map((item, index) => (
            <CalendarDashboardEvent
              key={index}
              {...item}
              onItemClick={() => {
                onItemClick(item);
              }}
            />
          ))
        : fallback}
    </CardList>
  );
};

export default TCalendarCardList;
